<div class="apg-panel">
  <app-site-content key="FullQuote.Declaration" [appScrollIntoView]="true"></app-site-content>

  <div class="summary__buttons">
    <ion-button (click)="back.emit()">
      <ion-icon name="chevron-back-outline"></ion-icon>
      Back
    </ion-button>

    <ion-button (click)="continue.emit()">
      Continue
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>
